// Automatically adds the "Shipping Protection" product to the cart whenever
// any other item is added, if it isn't already in the cart. Uses the same
// public cart-update event the theme itself dispatches on every native
// add-to-cart, so the cart drawer/badge refresh exactly as if a person had
// added it manually.
import { CartLinesUpdateEvent } from '@shopify/events';

const PROTECTION_VARIANT_ID = 58352375562614;
const originalFetch = window.fetch.bind(window);
let addingProtection = false;

console.log('[shipping-protection-auto-add] script loaded, watching for cart adds');

function isCartAddRequest(url) {
  if (typeof url !== 'string') return false;
  return /\/cart\/add(\.js)?(\?|$)/.test(url);
}

window.fetch = function (...args) {
  const input = args[0];
  const url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
  const fetchPromise = originalFetch(...args);

  if (isCartAddRequest(url)) {
    fetchPromise
      .then((response) => {
        if (response && response.ok) maybeAddProtection();
      })
      .catch(() => {});
  }

  return fetchPromise;
};

async function maybeAddProtection() {
  if (addingProtection) {
    console.log('[shipping-protection-auto-add] already in progress, skipping');
    return;
  }
  addingProtection = true;

  try {
    const cart = await originalFetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((response) => response.json());

    const alreadyPresent = cart.items.some((item) => String(item.variant_id) === String(PROTECTION_VARIANT_ID));
    if (alreadyPresent) {
      console.log('[shipping-protection-auto-add] already in cart, skipping');
      return;
    }

    console.log('[shipping-protection-auto-add] adding protection variant', PROTECTION_VARIANT_ID);

    const addResponse = await originalFetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: PROTECTION_VARIANT_ID, quantity: 1 }] }),
    });

    if (!addResponse.ok) {
      console.log('[shipping-protection-auto-add] add request failed', addResponse.status);
      return;
    }

    const updatedCart = await originalFetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((response) => response.json());

    console.log('[shipping-protection-auto-add] added successfully, cart now has', updatedCart.item_count, 'items');

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'shipping-protection-auto-add',
        lines: [{ merchandiseId: PROTECTION_VARIANT_ID, quantity: 1 }],
        promise: Promise.resolve({ cart: updatedCart }),
      })
    );
  } catch (error) {
    console.error('[shipping-protection-auto-add] Failed to add shipping protection', error);
  } finally {
    addingProtection = false;
  }
}
